module.exports = __webpack_public_path__ + "img/Flowchart-2.0.bf464868.png";